<!-- Runmode:A1/A1O/B/BO/NR5用のコンポーネント -->
<template>
  <div class="a1">
    <PinchInImg v-show="showPinchIn"/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

        <div v-if="isEnvironmentPc()" class="toparea-play">
          <div class="flexcenter" v-show="showSelectAnswer">
            <!-- 問題データ & 再生アイコン -->
            <div class="input w300"><div v-show="showText"><span v-html="getPopupTextElem(eText)" ></span></div></div>
            <button class="icon-voice item" @click="audioPlay(currentData.sounds[0])"></button>
          </div>
        </div>
        <div v-else class="toparea-play" :style="{ visibility: isAutoAdjustShown ? 'visible' : 'hidden' }">
          <div class="flexcenter" :style="{ visibility: showSelectAnswer ? 'visible' : 'hidden' }">
            <!-- 問題データ & 再生アイコン -->
            <div class="input w300"><span :style="{ visibility: showText ? 'visible' : 'hidden' }" v-html="eText"></span></div>
            <button class="icon-voice item" @click="audioPlay(currentData.sounds[0])"></button>
          </div>
        </div>

        <div class="cards-container active-type1" v-auto-adjust>
          <div v-for="(templateType, index) in templateTypes" class="card-inner card-voice" :class="templateType" :key="index">
            <div class="item" v-for="item in actGroupIndexList[index]" :class="{ challenge: isChallenge(pathstep.acts[item]) }" :key="item">
              <A1act :act="pathstep.acts[item]" :answer="currentData"
                      :questionState="questionStatus" :challengeFillPolicy="pathstep.challengeFillPolicy"
                      :runmode="pathstep.mode" :index="item" :isSelect="isSelect"
                      @audioPause="audioPause()" @isCorrect="childIsCorrect(item)" @isInCorrect="childIsInCorrect()" @clickImage="clickItem(pathstep.acts[item], item)"
                      @onTouchStart="onTouchStart" @onTouchEnd="onTouchEnd"/>
            </div>
          </div>
          <div v-if="isScrollIconVisible" class="icon-scroll" />
        </div><!-- /cards-container -->

      </div><!-- /inner -->
    </div><!-- /page-content -->
  <!-- /a1 -->
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

import Vue from "vue";
import Vuex from "vuex";
// コンポーネント
import A1act from "./A1act";
// 画像拡大モーダルコンポーネント
import PinchInImg from "./PinchInImg";

Vue.use(Vuex);

// Vuexで状態管理
const store = new Vuex.Store({
  state: {
    questionState: "start"
  },
  mutations: {
    changeQuestionState(state, payload) {
      state.questionState = payload.val;
    }
  }
});

export default {
  name: "A1",
  props: {
    pathstep: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  data() {
    return {
      // 出題用テキスト
      eText: "",
      // actのindex配列
      items: [],
      // 出題対象のactData
      currentData: null,
      // 出題済みactのindex配列
      currentIndex: [],
      // 正解済みactのindex配列
      correctIndex: [],
      // actのグループごとの配列
      actGroupIndexList: [],
      // 回答選択欄表示フラグ
      showSelectAnswer: false,
      // 正解／不正解を判断するフラグ（storeコミット用）
      isActState: true,
      // 画像選択可能かを判断するフラグ
      isSelect: false,
      // テキスト表示するかを判断するフラグ
      showText: false,
      // givenの問題をまとめたactの配列
      givenActs: false,
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // 退避用correctIndex
      tempCorrectIndex: -1,
      // sliderInitしたかを判定するフラグ
      isSliderInit: false,
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  computed: {
    questionStatus: function() {
      return store.state.questionState;
    },
    templateTypes: function() {
      // テンプレートクラス切り替え
      return this.getTemplateTypes();
    }
  },
  components: {
    A1act,
    PinchInImg
  },
  methods: {
    /**
    /* 初期化処理
     */
    init: function() {
      this.log("A1 start init");

      store.commit({ type: "changeQuestionState", val: "start" });

      const self = this;
      var iconVoice = $(".icon-voice");

      // 音声再生ボタンを無効にする
      iconVoice.addClass("disabled");
      $(iconVoice).prop("disabled", true);

      // ACTの取得
      this.items = this.getShuffleItems();
      this.setGroupIndexList(this.items);

      // テキストを表示するかを判定する
      this.isShowText();
    },
    /**
    /* 問題の出題
     */
    question: function() {
      this.log("A1 start question");

      const self = this;

      this.tempCorrectIndex = -1;

      // スコア表示中は問題出題しない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        this.showSelectAnswer = false;
        return;
      }

      var question = this.getQuestion(this.currentIndex);

      if (question == null) {
        // 問題を取得できなかった場合（最後の問題がgivenの場合）

        var iconVoice = $(".icon-voice");

        // 音声再生ボタンを有効にする
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);

        // 親（Runmode.Vue）に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
      } else {
        if (this.pathstep.mode == constants.RUNMODE_NR5) {
          this.challengeQuestion();
          this.currentIndex.push(-1);
        } else {
          if (this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex)) == -1) {
            // currentIndexが初期状態（何も値が設定されていない）の場合
            this.currentIndex.push(0);
          } else {
            // currentIndexの最大値 +1 をpushする
            this.currentIndex.push(this.currentIndex[this.currentIndex.indexOf(Math.max.apply(null, this.currentIndex))] + 1);
          }

          if (this.isChallenge(question)) {
            // challengeの場合

            this.challengeQuestion();
          } else {
            // givenの場合
            this.currentData = question;

            // 音声の再生
            this.audioPlay(question.sounds[0]);

            // 音声再生終了後、次の問題へ
            this.myAudio.onended = function() {
              self.setInterval(constants.QUESTION_INTERVAL).then(function() {
                self.question();
              });
            };
          }
        }
      }
    },
    /**
     * given問題の出題処理
     */
    givenQuestions: function() {
      this.log("A1 start givenQuestions");

      // givenの問題全てを取得し、再生する
      this.givenActs = this.getGivenQuestion();

      if (this.givenActs.length != 0) {
        this.givenPlaySounds(this.givenActs);
      } else {
        // givenの問題がない場合は、challengeの問題をランダム出題する
        this.question();
      }
    },
    /**
     * given問題の再生処理
     */
    givenPlaySounds: function(givenActs) {
      this.log("A1 start givenPlaySounds");

      const self = this;

      if (givenActs.length == 0) {
        // givenのactを全て再生し終わったら、challengeの問題をランダム出題する
        this.question();
        return;
      }

      this.currentData = givenActs[0];

      // 先頭のactの音声を再生する
      this.audioPlay(givenActs[0].sounds[0]);
      this.currentIndex.push(-1);

      // 音声再生終了後、次のactの音声を再生する
      this.myAudio.onended = function() {
        // 再生したら配列から削除する
        givenActs.shift();
        self.setInterval(constants.QUESTION_INTERVAL).then(function() {
          self.givenPlaySounds(givenActs);
        });
      };
    },
    /**
     * challenge問題の出題処理
     */
    challengeQuestion: function() {
      this.log("A1 start challengeQuestion");

      const self = this;

      // 問題データの取得_ランダム
      this.currentData = this.getQuestionRandom(this.correctIndex);

      if (this.currentData == null) {
        // 親(Runmode.Vue)に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
        return;
      }

      // 問題音声再生を実行する
      this.audioPlay(this.currentData.sounds[0]);
      // 問題文表示
      this.eText = this.currentData.basicText;
      // 回答選択欄の表示
      this.showSelectAnswer = true;
      // ツールバー押下していない場合は、画像選択可能にする
      if (!this.dispJapaneseStatus && !this.dispAllAnswerStatus) {
        this.isSelect = true;
      }
    },
    /**
    /* 画像押下処理
     */
    clickItem: function(A1act, index) {
      this.log("A1 start clickItem");

      const self = this;

      if (A1act.basicText == this.currentData.basicText) {
        // 正解の場合

        if (this.isAllCorrect(this.correctIndex.length)) {
          // 全問正解した場合

          // 全actの正解テキストを表示する
          store.commit({ type: "changeQuestionState", val: "end" });

          // 回答選択欄を非表示
          this.showSelectAnswer = false;
        } else {
          // 全問正解していない場合

          // 画像シャッフルするかを判定し、画像をシャッフルする
          this.items = this.getShuffleItems();
          this.setGroupIndexList(this.items);
        }

        // スコア表示中は次の問題出題しない
        if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
          this.showSelectAnswer = false;
          return;
        }

        if (this.currentIndex.length == this.pathstep.acts.length) {
          // 全ての問題（givenを含めて全て）を出題した場合

          var iconVoice = $(".icon-voice");

          // 音声再生ボタンを有効にする
          iconVoice.removeClass("disabled");
          $(iconVoice).prop("disabled", false);

          // 親(Runmode.Vue)に通知する
          this.allCorrectTimer = setTimeout(function() {
            self.$emit("endAct");
          }, constants.ALLCORRECT_INTERVAL);
        } else {
          // 全ての問題（givenを含めて全て）を出題していない場合

          // isActStateの初期化
          this.isActState = true;

          // 次の問題へ
          this.question();
        }
      } else {
        // 不正解の場合

        // 繰り返し同じ音声を再生する。
        if (!this.isAudioPlaying && this.isSelect && this.lessonState != storeConstants.LESSON_STATE_PAUSE) {
          this.audioPlay(this.currentData.sounds[0]);
        }
      }
    },
    setGroupIndexList: function(items) {
      this.log("A1 start setGroupIndexList");

      this.actGroupIndexList = [];
      const self = this;

      return new Promise(function(resolve, reject) {

        if(!self.isEnvironmentPc()) {
          switch (self.pathstep.layoutID) {
            case 2:
            case 3:
            case 4:
              // グループを一つにする
              self.actGroupIndexList = [items];
              resolve();
              return;
            case 5:
            case 6:
            case 32:
              // グループを一つにする
              var list = [];
              items.forEach(function(item) {
                item.forEach(function(act) {
                  list.push(act);
                })
              });
              self.actGroupIndexList = [list];
              resolve();
              return;
            default:
              break;    
          }
        }

        if (self.pathstep.groupNum == 0) {
          // グループなしの場合
          switch (items.length) {
            case 3:
              var singleItems = [];
              for (var i = 0; i < items.length; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            case 4:
              var singleItems = [];
              for (var i = 0; i < 2; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              singleItems = [];
              for (var i = 2; i < 4; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            case 5:
              var singleItems = [];
              for (var i = 0; i < 3; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              singleItems = [];
              for (var i = 3; i < 5; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            case 6:
              var singleItems = [];
              for (var i = 0; i < 3; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              singleItems = [];
              for (var i = 3; i < 6; i++) {
                singleItems.push(items[i]);
              }
              self.actGroupIndexList.push(singleItems);
              break;
            default:
              break;
          }
        } else {
          // グループありの場合
          if (self.pathstep.layoutID == 30) {
            self.actGroupIndexList = [[], []];
            for (var i = 0; i < items.length; i++) {
              for (var j = 0; j < items[i].length; j++) {
                if (i == 0) {
                  self.actGroupIndexList[0].push(items[i][j]);
                } else {
                  self.actGroupIndexList[1].push(items[i][j]);
                }
              }
            }
          } else {
            self.actGroupIndexList = items;
          }
        }
        resolve();
      });
    },
    /**
     *  ツールバー日本語翻訳／全解答表示押下前の状態に戻す
     */
    changeunDisp: function() {
      this.log("A1 start changeunDisp");

      this.eText = this.currentData.basicText;
      this.isShowText();

      // 問題文出題している場合は、画像選択可能にする
      if (this.showSelectAnswer) {
        this.isSelect = true;
      }
    },
    /**
     *  出題文の日本語訳を表示する
     */
    changeDispJapanese: function() {
      this.log("A1 start changeDispJapanese");

      this.eText = this.currentData.japaneseText;
      this.showText = true;
    },
    /**
     *  出題文に解答を表示する
     */
    changeDispAnswer: function() {
      this.log("A1 start changeDispAnswer");

      this.eText = this.currentData.basicText;
      this.showText = true;
    },
    /**
     * テキスト表示するかを判定する
     */
    isShowText: function() {
      this.log("A1 start isShowText");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
          this.showText = true;
          break;
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_NR5:
          this.showText = false;
          break;
        default:
          break;
      }
    },
    /**
     * Runmode毎にquestionの出題方法を変更する
     */
    setQuestionType: function() {
      this.log("A1 start setQuestionType");

      switch (this.pathstep.mode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
          this.question();
          break;
        case constants.RUNMODE_NR5:
          this.givenQuestions();
          break;
        default:
          break;
      }
    },
    /**
     * 子(A1act）で正解した場合の処理
     */
    childIsCorrect: function(index) {
      this.log("A1 start childIsCorrect");

      this.isSelect = false;
      // 正解済みのactを配列に追加する
      this.correctIndex.push(index);
      this.tempCorrectIndex = index;

      // スコアを登録
      this.setActState(this.isActState);
    },
    /**
     * 子(A1act）で不正解した場合の処理
     */
    childIsInCorrect: function() {
      this.log("A1 start childIsInCorrect");

      // スコアの値を不正解にする
      this.isActState = false;
    },
    /**
     * 出題文領域自動サイズ調整処理
     */
    autoAdjustTopArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let inputClone;
      let textClone;
      const cloneInput = function(targetText) {
        // 出題文領域を複製
        inputClone = $(".toparea-play > .flexcenter > .input").clone();
        textClone = inputClone.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        textClone.html(targetText);
        inputClone.appendTo(".toparea-play > .flexcenter");
      };

      // 出題文領域のフォントサイズを求める
      for (let question of this.getChallengeQuestions()) {
        // 英語で実施
        cloneInput(question.basicText);
        this.usTopAreaFontSize = this.getAutoAdjustFontSize(inputClone, textClone, this.usTopAreaFontSize);
        inputClone.remove();
        // 日本語で実施
        cloneInput(question.japaneseText);
        this.jpTopAreaFontSize = this.getAutoAdjustFontSize(inputClone, textClone, this.jpTopAreaFontSize);
        inputClone.remove();
      }
      // 出題文領域の高さを求める
      for (let question of this.getChallengeQuestions()) {
        // 英語で実施
        cloneInput(question.basicText);
        this.usTopAreaHeight = this.getAutoAdjustHeight(inputClone, textClone, this.usTopAreaHeight, this.usTopAreaFontSize);
        inputClone.remove();
        // 日本語で実施
        cloneInput(question.japaneseText);
        this.jpTopAreaHeight = this.getAutoAdjustHeight(inputClone, textClone, this.jpTopAreaHeight, this.jpTopAreaFontSize);
        inputClone.remove();
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .item:first").clone();
        clones.textArea = clones.card.children("div").children("p");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first");
      };

      // サイズを確定させる
      this.fixCardAreaSize(cloneCard, clones);
    },
    /**
     * 出題文領域サイズ適用
     */
    applyTopAreaSize: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.topAreaHeight;
      let fixedFontSize = fixedSize.topAreaFontSize;

      // 確定した高さとフォントサイズを設定
      let topArea = $(".toparea-play");
      let topAreaInput = topArea.children(".flexcenter").children(".input");
      topAreaInput.height(fixedHeight);
      topArea.height(topAreaInput.outerHeight());
      topAreaInput.children("span").css({ fontSize: fixedFontSize });

      // カード領域の位置と高さを調整する
      let topAreaHeight = topArea.outerHeight();
      let cardsContainer = $(".cards-container");
      let cardsContainerTop = cardsContainer.offset().top;
      let cardsContainerHeight = cardsContainer.outerHeight();
      let footerHeight = $(".sp-second-header").outerHeight();
      cardsContainer.css({
        top: topAreaHeight,
        height: cardsContainerHeight + cardsContainerTop - topAreaHeight - footerHeight
      });
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.cardAreaHeight;
      let fixedFontSize = fixedSize.cardAreaFontSize;
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .item > div > p");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
    },
    /**
     * 自動調整サイズ適用
     */
    applyAutoAdjustSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      this.applyTopAreaSize();
      this.applyCardAreaSize();
    },
    /**
     * 長押しイベント開始
     *
     * @param String imgpath 画像パス
     */
    onTouchStart: function(imgpath) {
      this.log("A1 start TouchEvent::" + imgpath);
      if (this.isEnvironmentPc()) {
        // PCの場合は表示しない
        return;
      }
      var self = this;

      this.touchTimer = setTimeout(function() {
        self.showPinchInImage(imgpath);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      this.log("A1 end TouchEvent");
      clearTimeout(this.touchTimer);
    }
  },
  mounted: function() {
    this.init();

    if (this.lessonState == storeConstants.LESSON_STATE_START) {
      // 問題の出題
      this.setQuestionType();
    }

    // 自動調整初期処理
    this.initAutoAdjust([".page-content"], [".cards-container"]);
  },
  created: function() {
    const self = this;

    // カスタムディレクティブ設定
    Vue.directive("auto-adjust", {
      // 子要素更新時に発火
      componentUpdated: function() {
        // カードシャッフル時にサイズを調整する
        if (self.isAutoAdjustShown && !self.dispJapaneseStatus && !self.dispAllAnswerStatus) {
          self.applyCardAreaSize();
        }
      }
    });
  },
  watch: {
    /**
     * ツールバー「日本語翻訳を表示する」の選択状態を監視する
     */
    dispJapaneseStatus: function(newstatus) {
      this.log("A1 watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.applyAutoAdjustSize();
          this.changeunDisp();
        }
      } else {
        this.applyAutoAdjustSize();
        this.changeDispJapanese();
        this.isSelect = false;
      }
    },
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A1 watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.applyAutoAdjustSize();
          this.changeunDisp();
        }
      } else {
        this.applyAutoAdjustSize();
        this.changeDispAnswer();
        this.isSelect = false;
      }
    },
    /**
    /* 音声再生状態を監視する
     */
    isAudioPlaying: function(newstatus) {
      this.log("A1 watch isAudioPlaying");

      var iconVoice = $(".icon-voice");

      if (this.isAudioPlaying) {
        // 音声再生ボタンを無効にする
        iconVoice.addClass("disabled");
        $(iconVoice).prop("disabled", true);
      } else {
        // 音声再生ボタンを有効にする
        iconVoice.removeClass("disabled");
        $(iconVoice).prop("disabled", false);
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(newstatus) {
      this.log("A1 watch lessonState");

      if (this.lessonState == storeConstants.LESSON_STATE_START) {
        // 問題の出題
        this.setQuestionType();
      } else if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
        if (!this.dispJapaneseStatus && !this.dispAllAnswerStatus) {
          if (this.correctIndex.indexOf(this.tempCorrectIndex) == -1) {
            this.currentIndex.pop();
          }
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        // ツールバー日本語翻訳／全解答表示中は何もしない
        if (!this.dispAllAnswerStatus && !this.dispJapaneseStatus) {
          if (this.pathstep.mode == constants.RUNMODE_NR5) {
            this.givenPlaySounds(this.givenActs);
          } else {
            this.question();
          }
        }
      }

      if (!this.isEnvironmentPc()) {
        // 表示領域自動調整
        let funcs = [this.autoAdjustTopArea, this.autoAdjustCardArea, this.applyAutoAdjustSize];
        this.autoAdjustFirstShown(funcs, [".cards-container"]);
        // スクロールアイコン表示
        this.$emit("showScrollIcon", document.getElementsByClassName("cards-container")[0]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A1.vue?3272b83e